import {BACKEND_ENDPOINT} from '../../../Constants'
import axiosInstance from '../../../config/AxiosConfig'

// Import GPs
export function importGPs(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/generalPractitioner/createGPs`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}

// Import Patients
export function importPatients(userId, hospitalId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/createPatients`, data, {
            params: {userId, hospitalId},
        })
        .then(res => res.data)
        .catch(error => error)
}

export function createAndDownloadXlsxSample(userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/createPatientXlsxSampleData`, null, {
            responseType: 'arraybuffer',
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}

export function createAndDownloadCsvSample(userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/createPatientCsvSampleData`, null, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}

// Import User Log
export function importUserLogs(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/log/createLogs`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}

export function createAndDownloadXlsxLogSample(userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/log/createUserLogXlsxSampleData`, null, {
            responseType: 'arraybuffer',
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}

export function createAndDownloadCsvLogSample(userId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/log/createUserLogCsvSampleData`, null, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}
